import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DenemePage = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/deneme-page`);
      if (response.ok) {
        const data = await response.json();
        setPageData(data);
      }
    } catch (error) {
      console.error('Error fetching page data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getColorClasses = (color) => {
    const colors = {
      red: 'from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20',
      blue: 'from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20',
      green: 'from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20',
      purple: 'from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20',
      yellow: 'from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20',
      pink: 'from-pink-50 to-pink-100 dark:from-pink-900/20 dark:to-pink-800/20'
    };
    return colors[color] || colors.red;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!pageData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600 dark:text-gray-400">Page not found</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-red-600 dark:text-gray-300 dark:hover:text-red-400 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 md:p-12">
          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            {pageData.title}
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            {pageData.subtitle}
          </p>

          {/* Divider */}
          <div className="border-t border-gray-200 dark:border-gray-700 my-8"></div>

          {/* Content Sections */}
          {pageData.content_sections && pageData.content_sections.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
              {pageData.content_sections.map((section, index) => (
                <div
                  key={index}
                  className={`bg-gradient-to-br ${getColorClasses(section.color)} p-6 rounded-xl`}
                >
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                    {section.title}
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    {section.description}
                  </p>
                </div>
              ))}
            </div>
          )}

          {/* CTA Section */}
          {pageData.cta_title && (
            <div className="mt-12 bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-4">
                {pageData.cta_title}
              </h3>
              {pageData.cta_description && (
                <p className="text-white/90 mb-6">
                  {pageData.cta_description}
                </p>
              )}
              <Link 
                to="/" 
                className="inline-block bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                {pageData.cta_button_text || 'Back to Home'}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DenemePage;
